"use client";

import { ChevronUp } from "lucide-react";
import { useEffect, useState } from "react";

const BackToTopButton = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setIsVisible(window.scrollY > 320);
    };

    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });

    return () => {
      window.removeEventListener("scroll", onScroll);
    };
  }, []);

  const goToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <button
      type="button"
      aria-label="العودة إلى الأعلى"
      onClick={goToTop}
      className={`fixed left-4 z-40 inline-flex h-10 w-10 items-center justify-center rounded-full border border-brand-red bg-brand-red text-white shadow-lg transition-all duration-300 hover:brightness-110 md:left-6 md:h-11 md:w-11 ${
        isVisible
          ? "bottom-[calc(4.5rem+env(safe-area-inset-bottom))] translate-y-0 opacity-100 md:bottom-6"
          : "pointer-events-none bottom-14 translate-y-4 opacity-0"
      }`}
    >
      <ChevronUp className="h-[18px] w-[18px] md:h-5 md:w-5" />
    </button>
  );
};

export default BackToTopButton;